<template>
    <div>
        <h5 class="comments-title font-weight-bold">
            {{ $t('enps.report.collaboratorsComments') }}
        </h5>
        <div ref="comments" class="comments-component pb-2 mb-4">
            <nav-bar
                class="mb-2"
                :model="selectedStatus"
                @change="onClickNavBarItem"
            />
            <div v-if="comments.length > 0 && !isLoading" class="pr-2 pl-2">
                <ListComments
                    :comments="comments"
                    :statusColor="getColorByStatus"
                />
                <b-pagination
                    size="sm"
                    class="mt-2 mb-0"
                    v-if="showPaginator"
                    :total-rows="pagination.total"
                    :per-page="pagination.perPage"
                    v-model="pagination.currentPage"
                />
            </div>
            <loader v-if="isLoading" loader />
            <div
                v-if="!isLoading && comments.length == 0"
                style="text-align: center"
            >
                {{ $t(`enps.report.withoutComments.${this.selectedStatus}`) }}
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '@/views/components/loader'
import { NavBar, ListComments } from './components'
import { getEnpsComments } from '../../../api'
export default {
    components: {
        NavBar,
        Loader,
        ListComments,
    },
    props: {
        filters: Object,
    },
    data() {
        return {
            isLoading: true,
            comments: [],
            selectedStatus: 'promoters',
            pagination: {
                total: null,
                perPage: 5,
                currentPage: 1,
            },
        }
    },
    computed: {
        showPaginator() {
            return this.pagination.total > this.pagination.perPage
        },
        getColorByStatus() {
            switch (this.selectedStatus) {
                case 'promoters':
                    return '#359C61'
                case 'neutral':
                    return '#E7A42F'
                case 'detractors':
                    return '#DE5B5B'
            }
        },
        requestParameters() {
            return {
                scopes: this.selectedStatus,
                per_page: this.pagination.perPage,
                page: this.pagination.currentPage,
                departments_ids: this.filters.departments,
                enps_researches_ids: this.filters.enpsResearches,
            }
        },
    },
    mounted() {
        this.getComments()
    },
    watch: {
        filters() {
            this.getComments()
        },
        'pagination.currentPage': function(newValue, oldValue) {
            if (newValue != oldValue) {
                this.getComments()
            }
        },
    },
    methods: {
        onClickNavBarItem(status) {
            if (this.selectedStatus !== status) {
                this.pagination.currentPage = 1
                this.selectedStatus = status
                this.getComments()
            }
        },
        getComments() {
            this.isLoading = true
            getEnpsComments(this.requestParameters)
                .then(({ data, total, per_page, current_page }) => {
                    this.comments = data
                    this.pagination = {
                        total,
                        perPage: per_page,
                        currentPage: current_page,
                    }
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
}
</script>

<style lang="sass" scoped>
$darkBlue: #022B4F

.comments-title
    color: #6e6e6e

.comments-component
    background-color: #F9F9F9
    border-radius: 5px

::v-deep
    .page-item.active .page-link
        background-color: $darkBlue
        border-color: $darkBlue
    .page-link
        color: $darkBlue
</style>
